/**
 * Checks if two URLs have the same origin.
 *
 * @param {string} url1 - The first URL to compare.
 * @param {string} url2 - The second URL to compare.
 * @returns {boolean} True if both URLs have the same origin, otherwise false.
 */
export const isSameOrigin = (url1: string, url2: string) => {
    try {
        const domain1 = new URL(url1).origin;
        const domain2 = new URL(url2).origin;
        return domain1 === domain2;
    } catch {
        return false;
    }
};

/**
 * Builds a URL with query parameters.
 *
 * @param {string} path - The base path of the URL.
 * @param {Record<string, string | number | boolean | null | undefined>} parameters - An object containing the query parameters.
 * @returns {string} The constructed URL with query parameters.
 */
export const buildURL = (
    path: string,
    parameters: Record<string, string | number | boolean | null | undefined>
): string => {
    const searchParams = new URLSearchParams();

    Object.entries(parameters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
            searchParams.append(key, String(value));
        }
    });

    const queryString = searchParams.toString();
    return queryString ? `${path}?${queryString}` : path;
};
